// One-time utility to add sample service rates
// This can be called from the browser console or executed once

import adminService from '../services/adminService';

const sampleServiceRates = [
  // Delivery Services - Weight-based pricing (matches the existing weight options)
  {
    serviceName: 'Up to 1 kg',
    basePrice: 50,
    pricePerUnit: 15,
    unit: 'km',
    maxWeight: 1,
    urgencyMultipliers: {
      standard: 1.0,
      express: 1.5,
      urgent: 2.0
    },
    isActive: true,
    categoryType: 'Delivery'
  },
  {
    serviceName: '1-3 kg',
    basePrice: 70,
    pricePerUnit: 15,
    unit: 'km',
    maxWeight: 3,
    urgencyMultipliers: {
      standard: 1.0,
      express: 1.5,
      urgent: 2.0
    },
    isActive: true,
    categoryType: 'Delivery'
  },
  {
    serviceName: '3-5 kg',
    basePrice: 90,
    pricePerUnit: 15,
    unit: 'km',
    maxWeight: 5,
    urgencyMultipliers: {
      standard: 1.0,
      express: 1.5,
      urgent: 2.0
    },
    isActive: true,
    categoryType: 'Delivery'
  },
  {
    serviceName: '5-10 kg',
    basePrice: 130,
    pricePerUnit: 15,
    unit: 'km',
    maxWeight: 10,
    urgencyMultipliers: {
      standard: 1.0,
      express: 1.5,
      urgent: 2.0
    },
    isActive: true,
    categoryType: 'Delivery'
  },
  {
    serviceName: '10-20 kg',
    basePrice: 200,
    pricePerUnit: 15,
    unit: 'km',
    maxWeight: 20,
    urgencyMultipliers: {
      standard: 1.0,
      express: 1.5,
      urgent: 2.0
    },
    isActive: true,
    categoryType: 'Delivery'
  },
  {
    serviceName: '20+ kg',
    basePrice: 300,
    pricePerUnit: 15,
    unit: 'km',
    maxWeight: 25,
    urgencyMultipliers: {
      standard: 1.0,
      express: 1.5,
      urgent: 2.0
    },
    isActive: true,
    categoryType: 'Delivery'
  },

  // Home Services - Electrical
  {
    serviceName: 'Basic Electrical Repair',
    basePrice: 200,
    pricePerUnit: 100,
    unit: 'hour',
    urgencyMultipliers: {
      standard: 1.0,
      express: 1.3,
      urgent: 1.8
    },
    isActive: true,
    categoryType: 'Electrical Services'
  },
  {
    serviceName: 'Ceiling Fan Installation',
    basePrice: 300,
    pricePerUnit: 0,
    unit: 'service',
    urgencyMultipliers: {
      standard: 1.0,
      express: 1.3,
      urgent: 1.8
    },
    isActive: true,
    categoryType: 'Electrical Services'
  },
  {
    serviceName: 'Switch & Socket Installation',
    basePrice: 150,
    pricePerUnit: 50,
    unit: 'piece',
    urgencyMultipliers: {
      standard: 1.0,
      express: 1.3,
      urgent: 1.8
    },
    isActive: true,
    categoryType: 'Electrical Services'
  },

  // Home Services - Plumbing
  {
    serviceName: 'Pipe Repair',
    basePrice: 250,
    pricePerUnit: 80,
    unit: 'hour',
    urgencyMultipliers: {
      standard: 1.0,
      express: 1.4,
      urgent: 1.9
    },
    isActive: true,
    categoryType: 'Plumbing Services'
  },
  {
    serviceName: 'Toilet Installation',
    basePrice: 800,
    pricePerUnit: 0,
    unit: 'service',
    urgencyMultipliers: {
      standard: 1.0,
      express: 1.4,
      urgent: 1.9
    },
    isActive: true,
    categoryType: 'Plumbing Services'
  },
  {
    serviceName: 'Tap Repair',
    basePrice: 180,
    pricePerUnit: 60,
    unit: 'hour',
    urgencyMultipliers: {
      standard: 1.0,
      express: 1.4,
      urgent: 1.9
    },
    isActive: true,
    categoryType: 'Plumbing Services'
  },

  // Home Services - AC Services
  {
    serviceName: 'AC Servicing',
    basePrice: 500,
    pricePerUnit: 0,
    unit: 'service',
    urgencyMultipliers: {
      standard: 1.0,
      express: 1.2,
      urgent: 1.6
    },
    isActive: true,
    categoryType: 'AC Services'
  },
  {
    serviceName: 'AC Installation',
    basePrice: 1200,
    pricePerUnit: 0,
    unit: 'service',
    urgencyMultipliers: {
      standard: 1.0,
      express: 1.2,
      urgent: 1.6
    },
    isActive: true,
    categoryType: 'AC Services'
  },
  {
    serviceName: 'AC Gas Refill',
    basePrice: 800,
    pricePerUnit: 0,
    unit: 'service',
    urgencyMultipliers: {
      standard: 1.0,
      express: 1.2,
      urgent: 1.6
    },
    isActive: true,
    categoryType: 'AC Services'
  },

  // Personal Care - Beauty Services
  {
    serviceName: 'Hair Cut & Style',
    basePrice: 300,
    pricePerUnit: 0,
    unit: 'service',
    urgencyMultipliers: {
      standard: 1.0,
      express: 1.2,
      urgent: 1.5
    },
    isActive: true,
    categoryType: 'Beauty Services'
  },
  {
    serviceName: 'Facial Treatment',
    basePrice: 600,
    pricePerUnit: 0,
    unit: 'service',
    urgencyMultipliers: {
      standard: 1.0,
      express: 1.2,
      urgent: 1.5
    },
    isActive: true,
    categoryType: 'Beauty Services'
  },
  {
    serviceName: 'Manicure & Pedicure',
    basePrice: 400,
    pricePerUnit: 0,
    unit: 'service',
    urgencyMultipliers: {
      standard: 1.0,
      express: 1.2,
      urgent: 1.5
    },
    isActive: true,
    categoryType: 'Beauty Services'
  },

  // Personal Care - Spa Services
  {
    serviceName: 'Full Body Massage',
    basePrice: 1000,
    pricePerUnit: 0,
    unit: 'service',
    urgencyMultipliers: {
      standard: 1.0,
      express: 1.2,
      urgent: 1.5
    },
    isActive: true,
    categoryType: 'Spa Services'
  },
  {
    serviceName: 'Head Massage',
    basePrice: 400,
    pricePerUnit: 0,
    unit: 'service',
    urgencyMultipliers: {
      standard: 1.0,
      express: 1.2,
      urgent: 1.5
    },
    isActive: true,
    categoryType: 'Spa Services'
  },

  // Emergency Services
  {
    serviceName: 'Emergency Electrical Fix',
    basePrice: 500,
    pricePerUnit: 200,
    unit: 'hour',
    urgencyMultipliers: {
      standard: 1.0,
      express: 1.5,
      urgent: 2.0
    },
    isActive: true,
    categoryType: 'Emergency Repair'
  },
  {
    serviceName: 'Emergency Plumbing',
    basePrice: 600,
    pricePerUnit: 150,
    unit: 'hour',
    urgencyMultipliers: {
      standard: 1.0,
      express: 1.5,
      urgent: 2.0
    },
    isActive: true,
    categoryType: 'Emergency Repair'
  },
  {
    serviceName: 'Emergency Package Delivery',
    basePrice: 150,
    pricePerUnit: 25,
    unit: 'km',
    maxWeight: 10,
    urgencyMultipliers: {
      standard: 1.0,
      express: 1.5,
      urgent: 2.0
    },
    isActive: true,
    categoryType: 'Emergency Delivery'
  }
];

export async function addSampleServiceRates(): Promise<{ totalAdded: number; totalSkipped: number }> {
  try {
    console.log('🔄 Starting to add sample service rates...');
    
    // Get all categories
    const categories = await adminService.getAllCategories();
    
    if (categories.length === 0) {
      console.log('❌ No categories found in database. Please create some categories first.');
      return { totalAdded: 0, totalSkipped: 0 };
    }
    
    console.log(`📊 Found ${categories.length} categories:`, categories.map(c => c.name));
    
    // Create category name to ID mapping
    const categoryMap = new Map(categories.map(cat => [cat.name, cat.id]));
    
    // For delivery services, try to find any category under the Delivery segment
    // If no specific "Delivery" category exists, create delivery services under the first delivery segment category
    let deliveryCategories = categories.filter(cat => {
      // Look for categories that might be under delivery segment
      return cat.name.toLowerCase().includes('delivery') || 
             cat.name.toLowerCase().includes('package') ||
             cat.name.toLowerCase().includes('courier');
    });
    
    // If no delivery-related categories found, check if there's a delivery segment and get its categories
    if (deliveryCategories.length === 0) {
      // Get all segments to find delivery segment
      const segments = await adminService.getAllSegments();
      const deliverySegment = segments.find(seg => seg.name.toLowerCase() === 'delivery');
      
      if (deliverySegment) {
        // Find categories under delivery segment
        deliveryCategories = categories.filter(cat => cat.segmentId === deliverySegment.id);
        console.log(`📦 Found ${deliveryCategories.length} categories under Delivery segment`);
      }
    }
    
    let totalAdded = 0;
    let totalSkipped = 0;
    
    // Add services to each category - ONLY DELIVERY SERVICES
    for (const service of sampleServiceRates) {
      // Skip non-delivery services to avoid duplicates
      if (service.categoryType !== 'Delivery') {
        console.log(`⏭️ Skipping ${service.serviceName} (${service.categoryType}) - only adding delivery services`);
        continue;
      }
      
      let categoryId = categoryMap.get(service.categoryType);
      
      // Special handling for delivery services
      if (!categoryId && service.categoryType === 'Delivery') {
        if (deliveryCategories.length > 0) {
          // Use the first delivery category found
          categoryId = deliveryCategories[0].id;
          console.log(`📦 Using delivery category: ${deliveryCategories[0].name} for ${service.serviceName}`);
        } else {
          console.log(`⚠️ No delivery categories found, will create delivery services under "Package Delivery" category`);
          
          // Create a delivery category if none exists
          const segments = await adminService.getAllSegments();
          const deliverySegment = segments.find(seg => seg.name.toLowerCase() === 'delivery');
          
          if (deliverySegment) {
            const categoryCreated = await adminService.createCategory({
              segmentId: deliverySegment.id,
              name: 'Package Delivery',
              icon: 'LocalShipping',
              description: 'Package delivery services with weight-based pricing',
              isActive: true
            });
            
            if (categoryCreated) {
              console.log(`✅ Created new delivery category: Package Delivery`);
              
              // Refresh categories to get the new category ID
              const updatedCategories = await adminService.getAllCategories();
              const newDeliveryCategory = updatedCategories.find(cat => 
                cat.name === 'Package Delivery' && cat.segmentId === deliverySegment.id
              );
              
              if (newDeliveryCategory) {
                categoryId = newDeliveryCategory.id;
                console.log(`📦 Using newly created delivery category: ${newDeliveryCategory.name}`);
              }
            }
          }
        }
      }
      
      if (!categoryId) {
        console.log(`⚠️ Category "${service.categoryType}" not found, skipping ${service.serviceName}`);
        totalSkipped++;
        continue;
      }
      
      try {
        const serviceData = {
          categoryId,
          serviceName: service.serviceName,
          basePrice: service.basePrice,
          pricePerUnit: service.pricePerUnit,
          unit: service.unit,
          maxWeight: service.maxWeight,
          urgencyMultipliers: service.urgencyMultipliers,
          isActive: service.isActive
        };
        
        const success = await adminService.createServiceRate(serviceData);
        
        if (success) {
          console.log(`✅ Added: ${service.serviceName} to ${service.categoryType} (₹${service.basePrice})`);
          totalAdded++;
        } else {
          console.log(`❌ Failed to add: ${service.serviceName}`);
        }
        
      } catch (error) {
        console.error(`❌ Error adding ${service.serviceName}:`, error);
      }
    }
    
    console.log(`\n🎉 Successfully added ${totalAdded} service rates to the database!`);
    if (totalSkipped > 0) {
      console.log(`⚠️ Skipped ${totalSkipped} services due to missing categories`);
    }
    console.log('✨ You can now view these services in the admin panel');
    
    return { totalAdded, totalSkipped };
    
  } catch (error) {
    console.error('💥 Error adding sample service rates:', error);
    return { totalAdded: 0, totalSkipped: 0 };
  }
}

// Make it available globally for console access
(window as any).addSampleServiceRates = addSampleServiceRates;